import type { UserOrgProfile } from '@/api/user/profile'

type EnabledFeatures = UserOrgProfile['enabled_features']
type EnabledFeatureKey = keyof EnabledFeatures

// Keep this ordered list in parity with capabilities.GrantFeatures(). The
// backend remains authoritative; this frontend mirror prevents unavailable
// navigation from mounting the conversation controller or opening its stream.
export const CONVERSATION_CAPABILITY_FEATURES = [
  'search_agent',
  'proposal_agent',
  'presentation_agent',
  'marketing_agent',
  'email_agent'
] as const satisfies ReadonlyArray<EnabledFeatureKey>

export function isConversationWorkspaceAvailable(features: EnabledFeatures | null | undefined): boolean {
  if (!features?.conversation_workspace) return false
  return CONVERSATION_CAPABILITY_FEATURES.some((feature) => features[feature])
}
